import { TypographySM } from "@/components/typography/SM";
import { Boxes, Pi } from "lucide-react";
import { LinkReference } from "./LinkReference";
import { OnboardingStep } from "./OnboardingStep";

interface Props {
  isCompleted: boolean;
}

export function UploadCodeStep({ isCompleted }: Props) {
  return (
    <OnboardingStep
      title="Upload your own code"
      icon={<Pi size={18} />}
      isCompleted={isCompleted}
    >
      <TypographySM className="mb-2 leading-6">
        Sharing apps with others is even more fun when you created the app code
        yourself. Upload your own code to Numerous.
      </TypographySM>

      <TypographySM className="leading-6">
        Deploy your own app by going to the{" "}
        <LinkReference icon={Boxes}>App Gallery</LinkReference> page and
        selecting &quot;Local Project&quot; from the deploy options. Or, follow
        the links to our documentation on the right if you prefer to use the
        Numerous CLI.
      </TypographySM>
    </OnboardingStep>
  );
}
